import request from '@/CommonDP/utils/request';
// 人员策划模块接口
export default {
  queryPersonList(data) {
    return request.post(`/prj-person-plan/role-person-list`, data);
  },

  queryPrjPersonPage(data) {
    return request.post(
      `/prj-person-plan/querySysUserInfoNotCheckedPage`,
      data
    );
  },

  queryPrjAllPerson(data) {
    return request.post(
      `/prj-person-plan/querySysUserInfoNotChecked`,
      data
    );
  },
  queryOtherPerson(data) {
    return request.post(`/prj-person-plan/query-user-list/temp`, data);
  },

  addPerson(data) {
    return request.post(`/prj-person-plan/add-person`, data);
  },

  delPerson(data) {
    return request.post(`/prj-person-plan/delete-person`, data);
  }
};
